<template>
  <div v-if="systemNotification">
    <div class="banner-container">
      <div class="banner-stage">
        {{ systemNotification.title }}
        &nbsp; - &nbsp;
        {{ systemNotification.message }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'EnvironmentBanner',
  data() {
    return {
      currEnv: process.env.CURRENT_ENV,
    };
  },
  computed: {
    ...mapState({
      systemNotification: (state) => state.admin.systemNotification,
    }),
  }
};
</script>
<style lang ="scss">
.banner-container{
  display: flex;
  justify-content: right;
  flex-direction: row;
  background-color: $BLACK;
}
.banner-dev{
  width: 100%;
  background-color: #F83356;
  color: white;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}
.banner-stage {
  width: 100%;
  background-color: #FFAB00;
  color: black;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
